class ConsoleLog {
  trace (message) {
    console.trace(message)
  }

  debug (message) {
    console.debug(message)
  }

  info (message) {
    console.info(message)
  }

  warn (message) {
    console.warn(message)
  }

  error (message) {
    console.error(message)
  }
}

export default new ConsoleLog()
